import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Typography, Grid, Button, CircularProgress } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import Modal from "../Modal";
import { translate as t } from "../../../../infrastructure/translate/localization";
import useStyles from "./styles";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import ModalContext from "../../../../infrastructure/Contexts/components/ModalWrapper/context";

export default function ActionConfirmationModal({
  title,
  message,
  isWarning,
  cantBeReverted,
  callback,
  callBackIsLoading,
  actionName,
  disableClose,
  withoutWrapper,
}) {
  const {
    container,
    icon,
    warning,
    textSeparation,
    button,
    outlinedButton,
    containedButton,
    progress,
  } = useStyles();

  const { closeModal } = useContext(ModalContext);

  const modalContents = (
    <Grid item container xs={12}>
      <Grid container className={container} item xs={12}>
        <Grid container item xs={12} justify="center">
          <ErrorIcon className={`${icon} ${isWarning && warning}`} />
        </Grid>
        <Grid
          item
          container
          xs={12}
          justify="center"
          className={textSeparation}
        >
          {message && (
            <Typography variant={disableClose ? "h5" : "body1"}>
              {message}
            </Typography>
          )}
        </Grid>
        <Grid
          item
          container
          xs={12}
          justify="center"
          className={textSeparation}
        >
          {cantBeReverted && (
            <Typography variant="body2">
              {t("common-messages.action-cannot-be-undone")}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} container justify="center">
        <Button
          variant="outlined"
          onClick={withoutWrapper ? closeModal : hideModal}
          className={`${button} ${outlinedButton}`}
          disabled={callBackIsLoading}
        >
          {t("actions.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={callback}
          className={`${button} ${containedButton}`}
          disabled={callBackIsLoading}
        >
          {callBackIsLoading && (
            <CircularProgress className={progress} size={15} />
          )}{" "}
          {actionName || t("actions.confirm")}
        </Button>
      </Grid>
    </Grid>
  );

  if (withoutWrapper) {
    return modalContents;
  }

  return (
    <Modal title={title} disableClose={disableClose}>
      {modalContents}
    </Modal>
  );
}

ActionConfirmationModal.defaultProps = {
  title: "",
  isWarning: false,
  cantBeReverted: false,
  callBackIsLoading: false,
  disableClose: false,
  actionName: null,
  withoutWrapper: false,
};

ActionConfirmationModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  isWarning: PropTypes.bool,
  cantBeReverted: PropTypes.bool,
  callback: PropTypes.func.isRequired,
  callBackIsLoading: PropTypes.bool,
  actionName: PropTypes.string,
  disableClose: PropTypes.bool,
  withoutWrapper: PropTypes.bool,
};
